import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import appReducer from './app';
import aadReducer from './aad';

export default combineReducers({
  app: appReducer,
  routing: routerReducer,
  aad: aadReducer,
});
